import React ,{useState}from 'react'
import { useNavigate , useParams} from 'react-router-dom';
import InputMask from 'react-input-mask';
import moment from 'moment'
import axios from 'axios';
import { Typeahead } from 'react-bootstrap-typeahead'; // Import Typeahead from react-bootstrap-typeahead
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Notification from './../../Components/assets/Modals/notification'
import NotifyError from '../assets/Modals/errorModal'
import AreaOfInterest from '../Constants/area_of_interest'
import JobTypeList from '../Constants/job_type'
import {RECRUIT_EMPLOYEE} from './../../url/index'

const Recruitment = () => {

  

    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false)
    const [IsSuccess, setSuccess] = useState(false)

    const[modalinfo, setMModalInfo] = useState({ msgList: [], title: ''})
    const[error_modal_info, setErrorModalInfo] = useState({ isHideErrorModal: true, msg: '', title: '',validationError:null})
    
    const [formData, setFormData] = useState({
       isTeachingStaff:null, area_of_interest:'', job_type:'',prev_Mark:'',experience:'', cell_Number:'',
       firstName: '', lastName: '', middleName:'' ,gender:'', dateOfBirth:'', 
       aadhar_number:'', address:'', base64Data:'', fileName:''});
    
    const [validate, setValidation] = useState(false);

    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);

    const validateForm = () => {
      
        return( 
          formData.isTeachingStaff !== null &&
         ((formData.isTeachingStaff == true && formData.area_of_interest != '')   || (formData.isTeachingStaff == false && formData.job_type != ''))  &&
         formData.prev_Mark != '' &&
         formData.cell_Number != '' &&
         formData.firstName.trim() !== '' && formData.lastName.trim() !== '' 
        &&  formData.gender.trim() !== '' && 
        (formData.dateOfBirth.trim() !== '' && !formData.dateOfBirth.trim().includes('_'))  && 
       
        (formData.aadhar_number.trim() !== '' && !formData.aadhar_number.trim().includes('_')) &&
        formData.address != '' && 
        file !== null
       
        );
      };

      const handleClose = () => {
        setSuccess(false)
        setFile(null)
        setError('')
        clearFormData()
        setValidation(false)
        //navigate(`/recruit`);
        window.location.reload();
        window.scrollTo(0, 0);
      }
      
      const handleCloseErrorModal = () => {
        setErrorModalInfo({title:"",
        msg: '', 
       validationError: null,
       isHideErrorModal: true
      })
      }
      
      const clearFormData = () => {
        setFormData({
          isTeachingStaff:null, area_of_interest:'', job_type:'',prev_Mark:'',experience:'', cell_Number:'',
       firstName: '', lastName: '', middleName:'' ,gender:'', dateOfBirth:'', 
       aadhar_number:'', address:'', base64Data:'', fileName:''
        });

        setFile(null);
       setError('');
      };

      const handleOptionSelect = (selected, id) => {
        if (selected.length > 0) {
          setFormData({ ...formData, [id]: selected[0].Name });
        }
      };
      
      // Handler for when the input value changes
      const handleInputChange = (text, id) => {
        setFormData({ ...formData, [id]: text });
      };


      const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          if (selectedFile.type === "application/pdf") {
            if (selectedFile.size <= 5 * 1024 * 1024) { // 5MB
              setFile(selectedFile);
              setError(null);
              
              const reader = new FileReader();
                  reader.readAsDataURL(selectedFile);
                  reader.onload = function () {
                    const fileData  = reader.result.split(',')[1]; // Extract base64 data
                    // Now you can send base64Data to your API
                   setFormData({...formData, base64Data: fileData, fileName: selectedFile.name})
                  };
                  reader.onerror = function (error) {
                    console.error('Error occurred while reading file:', error);
                  };

            } else {
              
              setFile(null);
              setError('File size exceeds 5MB.');

             

             
            }
          } else {
            setFile(null);
            setError('Please select a PDF file.');
          }
        }

       

      };

      const handleSave = async() => {
      
if(validateForm())
{
 let fileObj = {
  FileName:formData.fileName,
  Base64Data: formData.base64Data
 }

      const payLoad = {
        "IsTeachingStaff":formData.isTeachingStaff, 
        "Area_of_interest":formData.area_of_interest, 
        "Job_type":formData.job_type,
        "Prev_Mark":parseFloat(formData.prev_Mark),
        "Experience":formData.experience, 
        "Cell_Number":formData.cell_Number,
        "FirstName": formData.firstName,
        "MiddleName": formData.middleName,
        "LastName": formData.lastName,
        "Gender": formData.gender,
        "Dob": moment.utc(formData.dateOfBirth, "DD-MM-YYYY"),
        "AdhharNumber": formData.aadhar_number.replace(/\s+/g, ''),
        "Address":formData.address,
        "File": fileObj
    }

    try {
      setLoading(true)
     let response = await axios.post(RECRUIT_EMPLOYEE, payLoad);
    
     if(response.status === 201)
     {
      let temp = []
      temp.push("You have successfully applied for CTG Recruitment Drive")
      temp.push("Your registration number is " + response.data.Payload + ". Please note this registration number for future reference.")
      
      setLoading(false)
       setSuccess(true)
       setMModalInfo({title:"Success", msgList: temp})
       setValidation(false)
       clearFormData()
       
    }
    
    else{
      setLoading(false)
      setSuccess(true)
      setMModalInfo({title:"Error occurred!", msg: "Error Occurred...!", msgList:[]})
    }
    } catch (error) {
      setLoading(false)
      if(error.response.data)
        {
           if(error.response.status === 400)
         {
          
            if(error.response.data.Error.ValidationErrors != null)
            {
              const validationError =  error.response.data.Error.ValidationErrors
             
              setErrorModalInfo({title:"Validation Error occurred!",
               msg: error.response.data.Error.Message, 
              validationError: validationError,
              isHideErrorModal: false
            })
    
            }
            else{
    
              setErrorModalInfo({title:"Error occurred!",
              msg: error.response.data.Error.Message, 
             isHideErrorModal: false
           })
    
            }
         
         }
         else{
    
          setErrorModalInfo({title:"Error occurred!",
          msg: "Please contact support." , 
         isHideErrorModal: false
       })
         }
        }
        else
        setErrorModalInfo({title:"Error occurred!",
          msg: "Please contact support." , 
         isHideErrorModal: false
       })
    }
}
else{
  window.scrollTo(0, 0);
  setValidation(true)
  if(file == null)
  {
    if(error)
    {
      setError(error);
    }
    else{
      setError('Please upload a PDF file.');
    }
  }
  
}
      }

  //     const fileInput = document.getElementById('fileInput');
  // fileInput.addEventListener('change', function() {
  //   // Clear filename display
  //   this.nextElementSibling.textContent = '';
  // });

  return (
    <div className='emp'>
       <div className='container'>
       <div className='schoolheading'>
               <label className = 'emp-label'>CTG Group of Institutions</label>
               <br/>
               <label className = 'emp-label'>Recruitment</label>
               <div>
</div>
                </div>
       

                <div className="container mt-2">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8">
           
              <div className="card-body">
               
                  <div>
                    <form className="mb-2">

                    
                    <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span>Applying For:
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="teachingRadio"
              name="applytype"
              value={formData.isTeachingStaff}
              checked={formData.isTeachingStaff == null ? false : formData.isTeachingStaff}
              onChange={() =>
                setFormData({ ...formData, isTeachingStaff: true , job_type:'', prev_Mark:'',experience:''})
              }
            />
            <label className="form-check-label" htmlFor="teachingRadio">
              <span className = 'emp-label'>Teaching Staff</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="nonteachingRadio"
              name="applytype"
              value={formData.isTeachingStaff}
              checked={formData.isTeachingStaff == null ? false : !formData.isTeachingStaff}
              onChange={() =>
                setFormData({ ...formData, isTeachingStaff: false, area_of_interest:'', prev_Mark:'',experience:'' })
              }
            />
            <label className="form-check-label" htmlFor="nonteachingRadio">
            <span className = 'emp-label'>Non Teaching Staff</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
       
         {validate && formData.isTeachingStaff == null && (
          <small className="text-danger"> required.</small>
        )}
      </div>

      {formData.isTeachingStaff && 
      <div>

<div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span>Area of Interest:
        </label>
       

         <Typeahead
        id="area_of_interest"
        labelKey="Name"
        options={AreaOfInterest}
        placeholder="Search for an area of interest..."
        selected={[formData.area_of_interest]}
        onChange={(e) => handleOptionSelect(e, 'area_of_interest')}
        onInputChange={(e) => handleInputChange(e,'area_of_interest')} 
       // className={`form-control ${validate && formData.area_of_interest.trim() === '' ? 'is-invalid' : ''}`}
      /> 
      
        {validate && formData.area_of_interest.trim() === '' && (
          <small className="text-danger">Area  of Interest is required.</small>
        )}
                   </div>

                  
      </div>
                   
                   
                   
                   
                   }
                   {formData.isTeachingStaff == false && <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span>Job Type:
        </label>
       
       
         <Typeahead
        id="job_type"
        labelKey="Name"
        options={JobTypeList}
        placeholder="Search for a job type..."
        selected={[formData.job_type]}
        onChange={(e) => handleOptionSelect(e, 'job_type')}
        onInputChange={(e) => handleInputChange(e,'job_type')} 
      
      /> 
      
        {validate && formData.job_type.trim() === '' && (
          <small className="text-danger">Job Type is required.</small>
        )}
         
                   </div>}

 {/* name section */}

 {formData.isTeachingStaff !== null && 
 <div>
  <div className="form-group">
    {formData.isTeachingStaff == true &&
    <div>
        <label className = 'emp-label'>
        <span style={{color:'green', fontStyle: 'italic', fontSize:'14px'}}>M.Phill and PH.D candidates are preferable</span>
        </label>
        <br/>
        </div>
 }

  <label className = 'emp-label'>
  
  {formData.isTeachingStaff  == true ?
  <label>
    <span className="text-danger">*</span>
   <span>{' % of Marks in PG:'}</span>
   <span style={{color:'green', fontStyle: 'italic', fontSize:'14px'}}>{' (minimum 55% in PG)'}</span></label>
   :
    <span>Percentage of Marks in last qualification</span>}
  </label>
  <div class="input-group">
   <input 
  type="text" 
  class="form-control"
   id="prev_Mark" 
   value={formData.prev_Mark}
   className={`form-control ${validate && formData.prev_Mark.trim() === '' ? 'is-invalid' : ''}`}
  onChange={(e) =>
    {
    let value = e.target.value.replace(/[^\d.]/g, '')
    if(value.length >0)
    {
      let float_val = parseFloat(value)
      if(float_val < 100)
      {
        setFormData({ ...formData, prev_Mark: value })
      }
    }
    else{
       setFormData({ ...formData, prev_Mark: value })
    }
    //setFormDataStep3({ ...formDataStep3, prev_Mark: e.target.value.replace(/[^\d.]/g, '') })
    }
  }
  /> 


  <div class="input-group-append">
    <span class="input-group-text">%</span>
  </div>
</div>
{validate && formData.prev_Mark.trim() === '' && (
          <small className="text-danger">Last Qualification mark is required.</small>
        )}
</div>
 <div className="form-group">
 <label className = 'emp-label'>
 <span className="text-danger">*</span>Work Experience:
 </label>
 <select
   className={`form-control ${validate && formData.experience.trim() === '' ? 'is-invalid' : ''}`}
   value={formData.experience}
   onChange={(e) =>
     setFormData({ ...formData, experience: e.target.value })
   }
 >
  <option value="" disabled>Select</option>
  <option value={'No Experience'}>No Any Experience</option>
<option value={'1 year'}>1 year</option>
<option value={'2 year'}>2 year</option>
<option value={'3 year'}>3 year</option>
<option value={'4 year'}>4 year</option>
<option value={'5 year'}>5 year</option>
<option value={'More than 5 year'}>More than 5 yr</option>

 </select>
 {validate && formData.experience.trim() === '' && (
   <small className="text-danger">Experience is required.</small>
 )}
            </div>
               </div>
 
 }
 <br/>

<div className="mb-2 parent-form">
 <div className="parent-column">
                      <div className="form-group">
                        <label className = 'emp-label'><span className="text-danger">*</span>First Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validate && formData.firstName.trim() === '' ? 'is-invalid' : ''}`}

                          value={formData.firstName}
                          onChange={(e) =>
                            setFormData({ ...formData, firstName: e.target.value })
                          }
                        />
                        {validate && formData.firstName.trim() === '' && (
                          <small className="text-danger">First Name is required.</small>
                        )}
                      </div>
                      </div>
                      <div className="parent-column">
                      <div className="form-group">
                        <label className = 'emp-label'>Middle Name:</label>
                        <input
                          type="text"
                          className={`form-control`}

                          value={formData.middleName}
                          onChange={(e) =>
                            setFormData({ ...formData, middleName: e.target.value })
                          }
                        />
                      </div>
                      </div>
                      <div className="parent-column">
                      <div className="form-group">
                        <label className = 'emp-label'><span className="text-danger">*</span>Last Name:</label>
                        <input
                          type="text"
                          className={`form-control ${validate && formData.lastName.trim() === '' ? 'is-invalid' : ''}`}
                          value={formData.lastName}
                          onChange={(e) =>
                            setFormData({ ...formData, lastName: e.target.value })
                          }
                        />
                        {validate && formData.lastName.trim() === '' && (
                          <small className="text-danger">Last Name is required.</small>
                        )}
                      </div>

                      </div>

                      </div>

                     

                      <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span>Gender:
        </label>
        <div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="maleRadio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={() =>
                setFormData({ ...formData, gender: 'male' })
              }
            />
            <label className="form-check-label" htmlFor="maleRadio">
              <span className = 'emp-label'>Male</span>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              className="form-check-input"
              id="femaleRadio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={() =>
                setFormData({ ...formData, gender: 'female' })
              }
            />
            <label className="form-check-label" htmlFor="femaleRadio">
            <span className = 'emp-label'>Female</span>
            </label>
          </div>
          {/* Add more radio buttons as needed */}
        </div>
        {validate && !formData.gender && (
          <small className="text-danger">Gender is required.</small>
        )}
      </div>
 
                   
                      <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span> Date of Birth:
        </label>

        <InputMask
          mask="99/99/9999"
          className={`form-control ${validate && (formData.dateOfBirth.trim() === '' || formData.dateOfBirth.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formData.dateOfBirth}
          onChange={(e) =>
            setFormData({ ...formData, dateOfBirth: e.target.value })
          }
          placeholder="DD/MM/YYYY"
        />
        {validate && formData.dateOfBirth.trim() === '' && (
          <small className="text-danger">Date of Birth is required.</small>
        )}
      </div>

      <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span>Cell Number:
        </label>

        <div class="input-group">
<div class="input-group-append">
          <span class="input-group-text">+91</span>
        </div>

        <InputMask
          mask="9999999999"
          className={`form-control ${validate && (formData.cell_Number.trim() === '' || formData.cell_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formData.cell_Number}
          onChange={(e) =>
            setFormData({ ...formData, cell_Number: e.target.value})
          }
          placeholder="0000000000"
        />
        
      </div>
      {validate && formData.cell_Number.trim() === '' && (
          <small className="text-danger">Cell Number is required.</small>
        )}
      </div>  
                   <div className="form-group">
        <label className = 'emp-label'>
        <span className="text-danger">*</span> Aadhar Number:
        </label>

        <InputMask
          mask="9999 9999 9999"
          className={`form-control ${validate && (formData.aadhar_number.trim() === '' || formData.aadhar_number.trim().includes('_')) ? 'is-invalid' : ''}`}
          value={formData.aadhar_number}
          onChange={(e) =>
            setFormData({ ...formData, aadhar_number: e.target.value })
          }
          placeholder="0000 0000 0000"
        />
        {validate && formData.aadhar_number.trim() === '' && (
          <small className="text-danger">Aadhar number is required.</small>
        )}
      </div>

      <div className="form-group">
                        <label className = 'emp-label'><span className="text-danger">*</span>Address:</label>
                        <textarea 
                       className={`form-control ${validate && formData.address.trim() === '' ? 'is-invalid' : ''}`}
                        id="address"
                         rows="5"
                         value={formData.address}
                         onChange={(e) =>
                           setFormData({ ...formData, address: e.target.value })
                         }
                         >

                         </textarea>
                       
                        {validate && formData.address.trim() === '' && (
                          <small className="text-danger">Address is required.</small>
                        )}
                      </div>

                     
                    <div className="container mt-4">
                      <div className="form-group">
          <label className = 'emp-label'><span className="text-danger">*</span> Upload Resume:</label>
          <br/>
          <input
           type="file"
           className="form-control-file visually-hidden"
           id="fileInput"
           accept=".pdf"
           placeholder=''
            onChange={handleFileChange}
          />
          <label htmlFor="fileInput" className="btn btn-primary">
  Choose File
</label>
         
        </div>
        <small className="form-text text-muted">Please upload a PDF file (max size 5MB).</small>
</div>
                    </form>
                    {file && !error && (
        <div className="alert alert-success mt-3">
          Selected file: {file.name}
        </div>
      )}

                    {error && <div className="alert alert-danger mt-3">{error}</div>}
<div style={{ display: "flex", justifyContent: 'center' }}>
                    <button style={{"width": '100%'}} className="btn btn-primary position-relative" onClick={handleSave} disabled={isLoading}>
 
 Submit
 {isLoading && (
     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
   )}
</button>
</div>    
                  </div>
              </div>
           
             

          </div>
        </div>
      </div>
      
      </div>
      <Notification
IsSuccess = {IsSuccess}
handleClose = {handleClose}
msgList = {modalinfo.msgList}
title = {modalinfo.title}
/>

{!error_modal_info.isHideErrorModal && <NotifyError
isHide = {error_modal_info.isHideErrorModal}
 handleCloseErrorModal ={handleCloseErrorModal}
  title = {error_modal_info.title}
   message = {error_modal_info.msg}
    Errors ={error_modal_info.validationError}
/>} 
         </div>
  )
}

export default Recruitment